import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { CompactLogoIcon, ECompactLogoIconType } from '../../../web/components/svgs/icons/CompactLogoIcon';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { supportSharedStyles as ss } from './styles/supportSharedStyles';
import { SUPPORT_MASTHEAD_HEIGHT } from './supportLayoutConstants';

interface AdminSupportPageLayoutProps {
	children: React.ReactNode;
	sidebarChildren?: React.ReactNode;
	contentStyles?: StyleDeclarationValue[];
}

function SupportNavHeader() {
	return (
		<Link aria-label='Lev Admin home' className={css(ss.supportNavHeader)} title='Lev Admin home' to='/accounts'>
			<CompactLogoIcon height={30} type={ECompactLogoIconType.White} width={30} />
		</Link>
	);
}

/** Shared full-bleed admin shell for the support inbox, reports, and settings surfaces. */
export function AdminSupportPageLayout({ children, sidebarChildren, contentStyles }: AdminSupportPageLayoutProps) {
	return (
		<AdminDashboardPageLayout
			compactNav
			fullBleed
			mastheadHeight={SUPPORT_MASTHEAD_HEIGHT}
			mastheadNavigationFillsSpace
			navHeader={<SupportNavHeader />}
			navStyles={[ss.supportNav]}
			showMastheadDivider={false}
			sidebarChildren={sidebarChildren}
			contentStyles={contentStyles}
		>
			{children}
		</AdminDashboardPageLayout>
	);
}
